import { render, staticRenderFns } from "./PointsbackReport.vue?vue&type=template&id=4f641d15&"
import script from "./PointsbackReport.vue?vue&type=script&lang=js&"
export * from "./PointsbackReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports